
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";
    import {checkPhone, imageUrl} from '@/utils/common'


    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            status: '',
            op_id: '',
            de_id: '',
            r_ids: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 删除
        del(id:any) {
            this.$confirm('此操作删除该项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.post('A13006', {id}).then(res => {
                    this.$message.success('操作成功')
                    this.searchTable()
                })
            })
        }

        // 改变状态
        setStatus(id: any, status: any) {
            this.$confirm('此操作将改变该项的状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.post('A13004', {id,status}).then(res => {
                    this.$message.success('操作成功')
                    this.searchTable()
                })
            })

        }

        // 新建、配置
        ruleForm: any = {
            username: '',
            mobile: '',
            realname: '',
            email: '',
            op_id: '',
            de_id: '',
            r_ids: '',
            start_at: '',
            end_at: ''
        }
        date1: any = []
        editDialog = false
        btnloading = false
        add() {
            this.ruleForm = {
                username: '',
                mobile: '',
                realname: '',
                email: '',
                op_id: '',
                de_id: '',
                r_ids: '',
                start_at: '',
                end_at: ''
            }
            this.model = {
                image_url: "",
                image_name: ""
            }
            this.date1 = []
            this.editDialog = true
        }
        editO(row: any) {
            this.ruleForm = {
                id: row.id,
                username: row.username,
                mobile: row.mobile,
                realname: row.realname,
                email: row.email,
                op_id: row.op_id,
                de_id: row.de_id,
                r_ids: row.r_ids,
                start_at: row.start_at,
                end_at: row.end_at,

            }
            this.date1 = [row.start_at, row.end_at]
            this.model.image_url = row.qr_code
            this.model.image_name = row.qr_code
            this.editDialog = true
        }
        cancle() {
            this.editDialog = false;

        }

        baseUrl = imageUrl
        dataAuth: any = {};
        model: any = {
            image_url: "",
            image_name: ""
        };
        handleAvatarSuccess(res: any, file: any) {
            if(res.data && res.errcode == 0) {
                this.$message.success('上传成功')
                this.model.image_name = file.name;
                this.model.image_url = this.baseUrl + res.data;
            } else {
                this.$message.warning('上传失败，请重新上传')
            }

        }

        beforeAvatarUpload(file: any) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上传图片只能是 JPG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let _that = this;
            return new Promise(function (resolve, reject) {
                if (isJPG && isLt2M) {
                    api
                        .getPolicy({
                            file_name: file.name,
                        })
                        .then((data) => {
                            _that.dataAuth = data;
                            resolve(true);
                        })
                        .catch(() => {
                            reject(false);
                        });
                } else {
                    reject(false);
                }
            });
        }


        save() {
            if(!this.ruleForm.username) {
                this.$message.warning('请输入账号')
                return
            }
            if (!checkPhone(this.ruleForm.mobile)) {
                return
            }
            if(!this.ruleForm.realname) {
                this.$message.warning('请输入名称')
                return
            }
            if(!this.ruleForm.op_id) {
                this.$message.warning('请选择运营商')
                return
            }
            if(!this.ruleForm.de_id) {
                this.$message.warning('请选择部门')
                return
            }
            if(!this.ruleForm.r_ids) {
                this.$message.warning('请选择角色')
                return
            }
            if(this.date1.length == 0) {
                this.$message.warning('请选择有效期')
                return
            }
            this.ruleForm.start_at = this.date1[0]
            this.ruleForm.end_at = this.date1[1]
            this.ruleForm.r_ids = this.ruleForm.r_ids.toString()
            // if(this.model.image_url.indexOf('szzsfx.com') > -1 || this.model.image_url.indexOf('') > -1) {
            //     this.ruleForm.qr_code = this.model.image_url
            // } else {
            //     this.ruleForm.qr_code = this.baseUrl + this.model.image_url
            // }
            this.ruleForm.qr_code = this.model.image_url

            this.btnloading = true;
            api.post(this.ruleForm.id ? 'A13003' : 'A13002', this.ruleForm).then(res => {
                this.$message.success('操作成功')
                this.searchTable()
                this.editDialog = false
            }).finally(() => {
                this.btnloading = false;
            })



        }

        // 查看
        toDetail(id: any) {

        }
        //日志
        logDialog = false
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        logTable = []
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A13005', this.logSearch).then(res => {
                this.logTable = res.list;
                this.logTotal = res.total
            })
            this.logDialog = true
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A13001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        // 获取运营商
        operator = {}
        getOperatorSection() {
            api.getOperatorSection().then(res => {
                this.operator = res
            })
        }

        // 部门
        department = {}
        getDepartmentSection() {
            api.getDepartmentSection().then(res => {
                this.department = res
            })
        }

        // 角色
        role = {}
        getRoleSection() {
            api.getRoleSection().then(res => {
                this.role = res
            })
        }



        activated() {
            this.getOperatorSection()
            this.getDepartmentSection()
            this.getRoleSection()
            this.searchTable();
        }
    }
